module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAMAAADOBMQXAAAAWlBMVEX///9bW1uzs7NDQ0M/Pz9hYWHm5ub6+vonJyfMzMzS0tLf39/+/v5SUlIwMDDs7Oz19fUZGRmnp6dwcHCFhYVFRUXZ2dnGxsY5OTm5ublqamqUlJSYmJh3d3eBHoRfAAAAoElEQVQY03WQ2w7CIBQEOUCBUu4FClX//zctUozRug+TzWQTwkGoRXHHB0eUlThs9kU2vJIroZTCnhqxO5cPoWME4UmMk6Gy2wymOjdrcXduATF3u0zkaGwvGCE+fdmV/lp1aS+2tDIm9xIYYx+vCdAaqNBa72bYDN6QVPxBUvx7u9LbnEMyUWYMqf8C8a1apFwNrHVsz0NwrtrBGnv/kyeihglTc/pIkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/enterprise/Resource_Book.png
// module id = nsRA
// module chunks = 0